import ReactMarkdown from "react-markdown";

export type AnswerCitation = {
  index: number;
  pageStart: number | null;
  pageEnd: number | null;
};

export function linkedAnswerMarkdown(
  markdown: string,
  citations: readonly AnswerCitation[],
): string {
  const available = new Set(citations.map((citation) => citation.index));
  return markdown.replace(/\[资料\s*(\d+)\](?!\()/gu, (marker, rawIndex: string) => {
    const index = Number(rawIndex);
    return available.has(index)
      ? `[资料 ${index}](#citation-${index})`
      : marker;
  });
}

export function citationHrefIndex(href: string | undefined): number | null {
  const matched = href?.match(/^#citation-(\d+)$/u);
  return matched ? Number(matched[1]) : null;
}

export function citationPageLabel(citation: AnswerCitation): string {
  if (citation.pageStart === null) return "页码待校准";
  if (citation.pageEnd && citation.pageEnd !== citation.pageStart) {
    return `P.${citation.pageStart}–${citation.pageEnd}`;
  }
  return `P.${citation.pageStart}`;
}

export function AiAnswerContent({
  answer,
  citations,
  onJump,
}: {
  answer: string;
  citations: readonly AnswerCitation[];
  onJump: (page: number) => void;
}): React.JSX.Element {
  return (
    <>
      <div className="ai-answer-markdown">
        <ReactMarkdown
          components={{
            a: ({ href, children }) => {
              const index = citationHrefIndex(href);
              const citation = citations.find((item) => item.index === index);
              if (!citation) return <>{children}</>;
              return (
                <button
                  type="button"
                  className="inline-citation"
                  disabled={citation.pageStart === null}
                  title={`打开原刊 ${citationPageLabel(citation)}`}
                  onClick={() => {
                    if (citation.pageStart !== null) onJump(citation.pageStart);
                  }}
                >
                  {children}
                </button>
              );
            },
          }}
        >
          {linkedAnswerMarkdown(answer, citations)}
        </ReactMarkdown>
      </div>
      {citations.length > 0 && (
        <section className="citation-index" aria-label="资料索引">
          <h3>资料索引</h3>
          <div className="citation-row">
            {citations.map((citation) => (
              <button
                id={`citation-${citation.index}`}
                type="button"
                key={citation.index}
                disabled={citation.pageStart === null}
                onClick={() => {
                  if (citation.pageStart !== null) onJump(citation.pageStart);
                }}
              >
                <span>资料 {citation.index}</span>
                <small>{citationPageLabel(citation)}</small>
              </button>
            ))}
          </div>
        </section>
      )}
    </>
  );
}
